import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const SLR2_3FEET_LAYER_ID = 'slr2_3FeetLayer';

const layerConfig = {
  title: 'SLR 2.3 Feet',
};

function SLR2_3FeetLayer() {
  const dispatch = useDispatch();
  const { slr2_3FeetLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) => selectSourceById(state, slr2_3FeetLayer?.source));
  const cartoLayerProps = useCartoLayerProps({ source });

  if (slr2_3FeetLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: SLR2_3FEET_LAYER_ID,

      stroked: false,
      filled: true,
      getFillColor: [47, 137, 238],
      lineWidthMinPixels: 1,
      pickable: true,
      visible: slr2_3FeetLayer.visible,
      opacity: slr2_3FeetLayer.opacity,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: SLR2_3FEET_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['SLR_Zone_Area_Square_Meters'],
            }),
          };
        }
      },
    });
  }
}

export default SLR2_3FeetLayer;
